/**
 * @module read-only/readonlyui
 */

import { Plugin, ButtonView } from 'ckeditor5';

import lockIcon from '!!raw-loader!./theme/icons/contentlock.svg';
import unlockIcon from '!!raw-loader!./theme/icons/contentunlock.svg';

/**
 * The read-only UI feature.
 *
 * It introduces the `'readonly'` button that marks text as read-only.
 *
 * @extends module:core/plugin~Plugin
 */
export default class ReadOnlyUI extends Plugin {
    /**
     * @inheritDoc
     */
    init() {
        const editor = this.editor;
        const t = editor.t;

        editor.ui.componentFactory.add('readonly', locale => {
            const command = editor.commands.get('readonly');
            const view = new ButtonView(locale);

            view.set({
                icon: lockIcon,
                tooltip: true,
                isToggleable: true
            });

            view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
            view.bind('label').to(command, 'value', value => {
                return value ? t('Enable editing') : t('Disable editing');
            });

            this.listenTo(view, 'execute', () => {
                editor.execute('readonly');
                editor.editing.view.focus();
            });

            return view;
        });
    }
}
